import { createAction, props } from '@ngrx/store';
import { MonthlyAccounts } from '../model/accounting.model';


export const getMonthlyAccountStateSuccess = createAction(
  '[Accounting] get monthly account state success',
  props<{ monthlyAccountState: MonthlyAccounts[] }>()
);

export const getMonthlyAccountStateError = createAction(
  '[Accounting] get monthly account state error',
  props<{ error: string }>()
);
